import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmq } from './Stkmq-angular';

export const StkMq005List = [{ id: "T", name: "集保" }, { id: "C", name: "融資" }, { id: "L", name: "融券" }]; // 庫存種類

@Injectable({
  providedIn: 'root'
})
export class StkmqServicePkg extends JkEntityV2 {
  StkMq005List = StkMq005List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkmq();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MQ001: '商品代號', MQ002: '帳號', MQ003: '登入代號', MQ004: 'datetime', MQ005: '庫存種類', MQ006: '資額度(原始)', MQ007: '資額度(可用)', MQ008: '券額度(原始)', MQ009: '券額度(可用)', MQ010: '股數:昨日庫存', MQ011: '今日委買', MQ012: '今日委賣', MQ013: '今日買進成交', MQ014: '今日賣出成交', MQ015: '今日可回補可賣出', MQ016: '可資沖股數', MQ017: '可券沖股數', MQ018: '即時庫存', MQ019: 'X(此欄請忽略)', MQ020: '即時個股維持率'
    };

    this.fieldNames = 'MQ001,MQ002,MQ003,MQ004,MQ005,MQ006,MQ007,MQ008,MQ009,MQ010,MQ011,MQ012,MQ013,MQ014,MQ015,MQ016,MQ017,MQ018,MQ019,MQ020';
    this.fieldLengths = { MQ001: 8, MQ002: 20, MQ003: 10, MQ004: 0, MQ005: 1, MQ006: 11, MQ007: 11, MQ008: 11, MQ009: 11, MQ010: 8, MQ011: 11.2, MQ012: 11.2, MQ013: 11.2, MQ014: 11.2, MQ015: 11, MQ016: 11, MQ017: 11, MQ018: 11, MQ019: 1, MQ020: 8.4 };
    this.columnDefs = [
      { field: "MQ011", headerName: "今日委買", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ020", headerName: "即時個股維持率", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ019", headerName: "X(此欄請忽略)", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MQ018", headerName: "即時庫存", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ017", headerName: "可券沖股數", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ016", headerName: "可資沖股數", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ015", headerName: "今日可回補可賣出", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ014", headerName: "今日賣出成交", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ013", headerName: "今日買進成交", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ012", headerName: "今日委賣", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ001", headerName: "商品代號", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MQ010", headerName: "股數:昨日庫存", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ009", headerName: "券額度(可用)", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ008", headerName: "券額度(原始)", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ007", headerName: "資額度(可用)", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ006", headerName: "資額度(原始)", headerTooltip: "", width: 158, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MQ005", headerName: "庫存種類", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MQ004", headerName: "datetime", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "MQ003", headerName: "登入代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MQ002", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKMQ';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMQ.*  FROM STKMQ`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MQ001,MQ002,MQ003`;
    this.keyFields = ['MQ001', 'MQ002', 'MQ003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MQ001', 'MQ002', 'MQ003'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Stkmq): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmq): Promise<Stkmq> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
